import React, { useState } from "react";
// import Data from "../Data";
import Data from "../Data";
import { Link } from "react-router-dom";

export default function Mobile() {
  const data = Data.mobiles;

  return (
    <div className="mobile">
      <div className="container-fluid">
        <div className="row">
          {data.slice(0, 6).map((datas) => {
            return (
              <Link
                className="mobile-link "
                key={datas.id}
                to={{
                  pathname: `ProductView/${datas.name}`,
                  values: {
                    id: datas.id,
                    name: datas.name,
                    price: datas.price,
                    originalprice: datas.originalprice,
                    image: datas.image,
                    description: datas.desc,
                    rating: datas.rating,
                    quantity: datas.quantity,
                    weight: datas.weight,
                    availableoffer: datas.availableoffer,
                    memory: datas.memory,
                    ram: datas.ram,
                  },
                }}
              >
                <div className="text-center p-4" key={datas.id}>
                  <img className="img-fluid" src={datas.image} alt="" />
                  <h5>{datas.name}</h5>
                  <div className="row">
                    <div className="col">
                      <h4>{datas.ram}</h4>
                    </div>
                    <div className="col">
                      <h4>{datas.memory}</h4>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <h6 className="selling-price">₹{datas.price}</h6>
                    </div>
                    <div className="col">
                      <h6 className="original-price">₹{datas.price}</h6>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
